import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitGetTestsList = {
  user: string;
};

export type Tests = {
  id: string;
  score: number;
  type: string;
  creationDate: string;
};

export type ResponseGetTestsList = Tests[];

export const getTestsList = async (data: SubmitGetTestsList) => {
  const response = await axios.post(`${rootUrl}/psychologist/tests/list`, {
    user: data.user,
    token: getCookies('auth'),
  });

  return response.data;
};
